<template>
  <div class="serveBox">
    <!-- <iframe
      src="https://links.iartschool.com/chatlink.html"
      frameborder="0"
    ></iframe> -->
    <img src="@/assets/img/serve.png" alt="" srcset="" />
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "客服",
    };
  },
  data() {
    return {};
  },
  components: {},
  mounted() {
    var sUserAgent = navigator.userAgent.toLowerCase();
    if (sUserAgent.indexOf("micromessenger") != -1) {
      location.href = "https://work.weixin.qq.com/kfid/kfc6056e60392afe73c";
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.serveBox {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
